import { useCallback, useMemo, useState, useEffect } from 'react';

type Params = {
  data: Array<any> | undefined;
  page?: number;
  perPage?: number;
  onFilter?: (arr: Array<any>) => Array<any>;
}

type Response = {
  totalItems: number;
  dataSlice: Array<any>;
  currentPage: number;
  totalFilteredItems: number;
  onChangePage: (p: number) => void;
}

export function useClientPagination(params: Params): Response {
  const { data, perPage = 10, onFilter } = params;

  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    if (!data) return [];
    if (!onFilter) return data;
    return onFilter(data);
  }, [data, onFilter]);

  useEffect(() => {
    if (data?.length) {
      setPage(1);
    }
  }, [data?.length]);

  const dataSlice = useMemo(() => {
    if (!filtered) return [];
    return filtered.slice((page - 1) * perPage, page * perPage) ;
  }, [filtered, page, perPage]);

  const handleChangePage = useCallback((p) => {
    setPage(p);
  }, []);

  return {
    dataSlice,
    totalItems: data?.length ?? 0,
    currentPage: page,
    totalFilteredItems: filtered?.length ?? 0,
    onChangePage: handleChangePage,
  }
}
